module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_c('span', [_vm._v("Content")])]), _vm._v(" "), _c('table', {
    attrs: {
      "cellpadding": "3",
      "cellspacing": "3",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "75%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "left-b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Acknowledgements",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("Ackowledgements")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "left-a"
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "75%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "left-b1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/frontmatter1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("Preface to the Second Edition")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "left-a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01"
    }
  }, [_vm._v("One")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "75%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "left-b"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01"
    }
  }, [_vm._v("Understanding as Translation")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "left-a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Two")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "75%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "left-b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Language and Gnosis")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "left-a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Three")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "75%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "left-b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Word against Object")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "left-a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Four")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "75%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "left-b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Claims of Theory")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "left-a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Five")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "75%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "left-b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Hermeneutic Motion")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "left-a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Six")])])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "75%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "left-b1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Topologies of Culture")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "left-a1"
  })]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "75%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "left-b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Afterword",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("Afterward")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "75%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "left-b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("Select Bibliography")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "25%"
    },
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "75%"
    },
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "left-b"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("Index of Proper Names and Titles")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d7b0912","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/content.vue
// module id = 75
// module chunks = 0